import { Component, QueryList, ViewChildren } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CalibrationBalance, CalibrationBalanceEssayAsFound, CalibrationBalanceEssayAsLeft, CalibrationBalanceEssayAsLeftValue, CalibrationBalancePattern, CalibrationBalanceResponsibleEnum, CalibrationBalanceStatus, CalibrationBalanceVariable, CalibrationBalanceVariableConfig, CalibrationBalanceVariableEssay, CalibrationBalanceVariablePoints } from '../../../../model/calibrationBalance';
import { InternalEquipment, InternalEquipmentTypeEnum } from '../../../../model/internalEquipment';
import { DateTime } from 'luxon';
import { InternalEquipmentPerformances } from '../../../../model/internalEquipmentPerformances';
import { CustomDatepickerHeaderComponent } from '../../../shared/datepicker-custom-header/datepicker-custom-header.component';
import _ from 'lodash';
import { SpinnerService } from '../../../../services/spinner.service';
import { UserService } from '../../../../services/user.service';
import { User } from '../../../../model/user';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../../../utils/constants';
import { ClientService } from '../../../../services/client.service';
import { Client } from '../../../../model/client';
import { InternalEquipmentService } from '../../../../services/internalEquipment.service';
import { DateUtils } from '../../../../utils/dateUtils';
import { ManageGroupsService } from '../../../../services/manageGroups.service';
import { GroupUtils } from '../../../../utils/groupUtils';
import { Group } from 'src/app/model/group';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { MatDialog } from '@angular/material/dialog';
import { ActionConfirmPasswordComponent } from '../../../shared/action-confirm-password/action-confirm-password.component';
import { CalibrationBalanceService } from '../../../../services/calibrationBalance.service';
import { StringUtils } from '../../../../utils/stringUtils';
import { ArrayUtils } from '../../../../utils/arrayUtils';
import { CalibrationBalanceUtils } from '../../../../utils/calibrationBalanceUtils';
import { Variable, VariableTypeEnum, VariableUnit } from '../../../../model/variable';
import { CalibrationBalanceEditConfirmSaveComponent, DialogDataConfirmSave } from '../calibration-balance-edit-confirm-save-component/calibration-balance-edit-confirm-save.component';
import { CalibrationBalanceEditConfigDialogComponent } from '../calibration-balance-edit-config-dialog-component/calibration-balance-edit-config-dialog.component';
import { EquipmentAutocompleteFilter } from '../../../../model/autocompleteFilter';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { CalibrationBalanceEditCreateEquipmentComponent } from '../calibration-balance-edit-create-equipment/calibration-balance-edit-create-equipment.component';
import { ExternalCalibrationValue } from '../../../../model/calibration';
import { ReasonDialogComponent } from '../../../shared/reason-dialog/reason-dialog.component';
import { ConfirmationDialogComponent } from '../../../shared/confirmation-dialog/confirmation-dialog.component';
import { CalibrationStatusService } from '../../../../services/calibrationStatus.service';
import { ProcedureService } from '../../../../services/procedure.service';
import { CalibrationPlaceService } from '../../../../services/calibrationPlace.service';
import { GenericClass, GenericClassTranslate, GenericWarnError } from '../../../../model/genericClass';
import { Procedure } from '../../../../model/procedure';
import { BalanceEssayTypeService } from '../../../../services/balanceEssayType.service';
import { BalanceEssayType, BalanceEssayTypeEnum } from '../../../../model/balanceEssayType';
import { VariableTypeService } from '../../../../services/variableType.service';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatSelectChange } from '@angular/material/select';
import { v4 as uuid } from 'uuid';
import { MatTable } from '@angular/material/table';
import { CalibrationBalanceEditPatternsDialogComponent } from '../calibration-balance-edit-patterns-dialog/calibration-balance-edit-patterns-dialog.component';
import { CalibrationBalanceEditAsLeftDialogComponent } from '../calibration-balance-edit-as-left-dialog/calibration-balance-edit-as-left-dialog.component';
import { NumberUtils } from '../../../../utils/numberUtils';
import { CalibrationBalanceEditSelectPointsComponent } from '../calibration-balance-edit-select-points/calibration-balance-edit-select-points.component';
import { CalibrationBalanceEditAsFoundDialogComponent } from '../calibration-balance-edit-as-found-dialog/calibration-balance-edit-as-found-dialog.component';
import { CalibrationBalanceEditGenerateReportComponent } from '../calibration-balance-edit-generate-report/calibration-balance-edit-generate-report.component';
import { InternalEquipmentSelectFolderComponent } from '../../../shared/internal-equipment-select-folder/internal-equipment-select-folder.component';
import { CheckWarnsErrorsComponent } from '../../../shared/check-warns-errors/check-warns-errors.component';
import { InternalEquipmentFolder } from '../../../../model/internalEquipmentFolder';
import { CalibrationBalanceEditAutomaticSignReportComponent } from '../calibration-balance-edit-automatic-sign-report/calibration-balance-edit-automatic-sign-report.component';
import { CalibrationBalanceEditManualSignReportComponent } from '../calibration-balance-edit-manual-sign-report/calibration-balance-edit-manual-sign-report.component';
import { RoleEnum } from '../../../../model/roleUser';
import { AppTypeEnum } from '../../../../model/appType';

@Component({
  selector: 'app-calibration-balance-edit',
  templateUrl: './calibration-balance-edit.component.html',
  styleUrl: './calibration-balance-edit.component.scss',
  standalone: false
})
export class CalibrationBalanceEditComponent {

  @ViewChildren('configTable') configTables: MatTable<any> | QueryList<MatTable<any>>;
  @ViewChildren('patternsTable') patternsTables: MatTable<any> | QueryList<MatTable<any>>;
  @ViewChildren('asLeftTableRepetibility') asLeftRepetibilityTables: MatTable<any> | QueryList<MatTable<any>>;
  @ViewChildren('asLeftTable') asLeftTables: MatTable<any> | QueryList<MatTable<any>>;
  @ViewChildren('uncertaintiesTable') uncertaintiesTable: MatTable<any> | QueryList<MatTable<any>>;
  @ViewChildren('asLeftTableEccentricity') asLeftTableEccentricity: MatTable<any> | QueryList<MatTable<any>>;
  @ViewChildren('asLeftTableMinimumWeight') asLeftTableMinimumWeight: MatTable<any> | QueryList<MatTable<any>>;
  @ViewChildren('asFoundTable') asFoundTables: MatTable<any> | QueryList<MatTable<any>>;

  calibration: CalibrationBalance;
  equipment: InternalEquipment;

  idClientSelected: number;
  clientName: string;
  clientAddress: string;
  clients: Client[] = [];
  clientsFiltered: Client[] = [];

  statuses: GenericClass[];
  procedures: Procedure[];
  places: GenericClassTranslate[];

  balanceEssayTypes: BalanceEssayType[];
  variablesSelected: Variable[];
  variables: Variable[] = [];
  variableUnits: VariableUnit[];
  variableUnitsExtra: VariableUnit[];
  equipmentCalibration: InternalEquipmentPerformances = new InternalEquipmentPerformances();
  vBalanceMass: ExternalCalibrationValue[] = [];
  maxDateCalibration = new Date();
  currentUser: User;
  count = 0;
  public equipmentAutoComplete: InternalEquipment[];
  customDatepickerHeader = CustomDatepickerHeaderComponent;
  
  configCols = ['range', 'resolution', 'tolerance', 'uncertaintyResolution', 'values', 'edit', 'delete'];
  patternsCols = ['name', 'equipment', 'maker', 'model', 'serialNum', 'uncertainty', 'edit', 'delete'];
  asLeftCols = ['number', 'point', 'pattern', 'value', 'average', 'cPlusU', 'edit'];
  asRepetibilityCols = ['number', 'pattern', 'value', 'desvesta', 'average', 'correction',  'edit'];
  asEccentricityCols = ['number', 'value',  'edit'];
  asMinimumWeightCols = ['number', 'value', 'pMResult', '820d'];
  asFoundCols = ['number', 'point', 'pattern', 'equipment', 'correction', 'edit'];

  orderEssayList = [BalanceEssayTypeEnum.ESSAY_REPEATABILTY, BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL, BalanceEssayTypeEnum.ESSAY_ECCENTRICITY, BalanceEssayTypeEnum.ESSAY_TARE, BalanceEssayTypeEnum.ESSAY_MINIMUM_WEIGHT];

  uncertaintiesCols = ['number', 'point','uResol', 'uExc', 'uHister', 'uRep', 'uPattern', 'uUnif', 'uEstab', 'uc', 'neff', 'k', 'U', 'measureUnit'];

  filteredProcedures: any[] = [];

  private destroy$ = new Subject<void>();
  
  constructor(
    private calibrationBalanceService: CalibrationBalanceService,
    private internalEquipmentService: InternalEquipmentService,
    private clientService: ClientService,
    private calibrationStatusService: CalibrationStatusService,
    private procedureService: ProcedureService,
    private calibrationPlaceService: CalibrationPlaceService,
    private balanceEssayTypeService: BalanceEssayTypeService,
    private variableTypeService: VariableTypeService,
    private userService: UserService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private spinnerService: SpinnerService,
    private snackBarService: SnackBarService,
    private manageGroupsService: ManageGroupsService) {
    this.spinnerService.show();

    this.currentUser = this.userService.currentProfile;

    this.equipment = new InternalEquipment();
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const id = params[Constants.FIELD_ID] as number;
      const idEquipment = params[Constants.FIELD_ID_EQUIPMENT] as number;

      if (id == null || isNaN(+id)) {
        this.cancel();
      }

      this.calibration = new CalibrationBalance();

      this.calibration.calibrationDate = DateTime.now().toJSDate();
      this.calibration.actionType = 1;
      if (+id === 0) {
        this.clientService.findAll().pipe(takeUntil(this.destroy$)).subscribe((clients: Client[]) => {
          this.clients = clients;
          this.clientsFiltered = this.clients;
        });

        if (idEquipment != null) {
          this.spinnerService.show();
          this.internalEquipmentService.findOne(idEquipment).pipe(takeUntil(this.destroy$)).subscribe((eq: InternalEquipment) => {
            this.onEquipmentChange(eq);
            if (this.equipment.performances?.length > 0) {
              const rCalibration = this.equipment.performances.find(t => t.idActionType === 1);
              if (rCalibration) {
                this.equipmentCalibration = rCalibration;
                if (rCalibration && rCalibration?.frequency?.match('^[0-9]+$')) {
                  this.equipmentCalibration.expirationDate = _.cloneDeep(this.calibration.calibrationDate);
                  this.equipmentCalibration.expirationDate.setMonth(this.calibration.expirationDate.getMonth() + Number(rCalibration.frequency));
                } else {
                  if (!this.calibration.expirationDate) {
                    this.calibration.expirationDate = _.cloneDeep(this.calibration.calibrationDate);
                    this.calibration.expirationDate.setFullYear(this.calibration.expirationDate.getFullYear() + 1);
                  }
                }
              }
            }
            this.idClientSelected = eq.internal ? -1 : eq.idClient;
            this.spinnerService.hide();
          }, () => this.spinnerService.hide());
        } else {
          this.spinnerService.hide();
        }
      } else {
        this.calibrationBalanceService.getOne(id).pipe(takeUntil(this.destroy$)).subscribe((result: any) => {
          if (result != null) {
            this.calibration = result;
            this.calibration.calibrationDate = DateUtils.anyToDate(this.calibration.calibrationDate);
            this.calibration.expirationDate = DateUtils.anyToDate(this.calibration.expirationDate);

            this.calibration.variables?.forEach((v: CalibrationBalanceVariable, vIndex: number) => {
              const variable = this.variables?.find(va => va.id === v.idVariable);

              if (variable != null) {
                this.variablesSelected.push(variable);
              }
              v.essays.forEach((e: CalibrationBalanceVariableEssay, indexEssay: number) => {
                this.onBlurSpm(vIndex, e);
                if (e.asLeft?.length > 0) {
                  e.asLeft?.sort((a, b) => (a.point > b.point) ? 1 : ((b.point > a.point) ? -1 : 0));
                  this.configurateAsLeft(vIndex, indexEssay);
                }
              });
              v.essays?.sort((a1, a2) => a1.idEssayType - a2.idEssayType);
            });
            
            this.onVariableTabChange(0);
            
            internalEquipmentService.findOne(this.calibration.idEquipment).pipe(takeUntil(this.destroy$))
              .subscribe((item: InternalEquipment) => {
                this.equipment = item;

                if (this.equipment.performances?.length > 0) {
                  const rCalibration = this.equipment.performances.find(t => t.idActionType === 1);
                  if (rCalibration) {
                    this.equipmentCalibration = rCalibration;
                  }
                }
                this.calculateClientData();
              }, () => this.spinnerService.hide());
          } else {
            this.calibration = new CalibrationBalance();
          }
        }, () => {
          this.calibration = new CalibrationBalance();
          this.spinnerService.hide();
        }, () => {
          if (this.calibration == null) {
            this.cancel();
          }
        });
      }

    });
  }

  ngOnInit(): void {
    this.statuses = [];
    this.procedures = [];
    this.places = [];
    this.variablesSelected = [];
    const disallowedVariables: number[] = [VariableTypeEnum.LETHALITY];

    this.calibrationStatusService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: GenericClass[]) => this.statuses = data);
    this.procedureService.getProceduresByIdApplication(AppTypeEnum.CALIBRATES).pipe(takeUntil(this.destroy$)).subscribe((data: Procedure[]) => {
      this.procedures = data;
      this.filteredProcedures = [...this.procedures];
    });
    this.calibrationPlaceService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: GenericClassTranslate[]) => {
      this.places = data;
      if (ArrayUtils.isNotEmpty(data) && !this.calibration.idPlace) {
        this.calibration.idPlace = data[0].id;
      }
    });
    this.balanceEssayTypeService.getAll().pipe(takeUntil(this.destroy$)).subscribe((data: BalanceEssayType[]) => this.balanceEssayTypes = data);

    this.variableTypeService.findAllCalibrates().pipe(takeUntil(this.destroy$)).subscribe((data: Variable[]) => {
      this.variables = data.filter(v => !disallowedVariables.includes(v.id));
      if (this.calibration && this.calibration?.variables) {
        this.calibration.variables.forEach((v: CalibrationBalanceVariable, vIndex: number) => {

          const variable = this.variables.find(va => va.id === v.idVariable);

          if (variable != null) {
            this.variablesSelected.push(variable);
          }
        });
      }
    });
    
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showExtraField(variable: CalibrationBalanceVariable): boolean {
    return CalibrationBalanceUtils.showExtraField(variable);
  }

  getExtraFieldName(variable: CalibrationBalanceVariable): string {
    return CalibrationBalanceUtils.getExtraFieldName(variable);
  }
  
  onTabChange(event: MatTabChangeEvent): void {
    if (event.index === 1) {
      //this.audit.getAudit();
    }
  }

  isEditable(): boolean {
    return this.calibration.idStatus === CalibrationBalanceStatus.PENDIENTE_FIRMA || this.calibration.idStatus === CalibrationBalanceStatus.FIRMADO || this.calibration.idStatus === CalibrationBalanceStatus.NO_VALIDO;
  }

  saveDate(field: string, event: any): void {
    let value: Date | string = event.value;

    if (value != null) {

      if (value instanceof Date) {
        value = DateTime.fromJSDate(value).toFormat('dd/MM/yyyy');
      }

      let date = DateTime.fromFormat(value + ' 12:00:00 +00:00', 'dd/MM/yyyy HH:mm:ss Z');

      while (date.year < 1970) {
        date = date.plus({ years: 100 });
      }

      this.calibration[field] = date?.toJSDate();

      if (field === 'calibrationDate') {
        if (this.calibration.expirationDate === null || !this.calibration.expirationDate) {
          if (this.equipmentCalibration.frequency && this.equipmentCalibration.frequency?.match('^[0-9]+$')) {
            this.calibration.expirationDate = _.cloneDeep(this.calibration.calibrationDate);
            this.calibration.expirationDate.setMonth(this.calibration.expirationDate.getMonth() + Number(this.equipmentCalibration.frequency));
          } else {
            this.calibration.expirationDate = _.cloneDeep(this.calibration.calibrationDate);
            this.calibration.expirationDate.setFullYear(this.calibration.expirationDate.getFullYear() + 1);
          }
        }
      }

    } else {
      this.calibration[field] = null;
    }
  }

  cancel(): void {
    void this.router.navigateByUrl('balances/calibrations');
  }

  saveCalibration(): void {
    const errors = this.checkCalibration(true, false);

    if (errors.length !== 0) {
      this.snackBarService.sendError(errors.join('\n'));

      return;
    }

    this.performSave();
  }

  lookupEquipment($event): void {
    let results = this.equipmentAutoComplete;

    const filter = new EquipmentAutocompleteFilter();

    filter.query = $event.target.value as string;
    filter.pageIndex = 0;
    filter.pageSize = 10;
    filter.sortBy = 'name';
    filter.sortDirection = 'asc';
    filter.forBalance = true;

    if (this.idClientSelected != null) {
      if (typeof this.idClientSelected === 'string') {
        if (this.idClientSelected !== '-1') {
          filter.idClient = Number(this.idClientSelected);
        } else {
          filter.internalEquipment = true;
        }
      } else {
        if (this.idClientSelected !== -1) {
          filter.idClient = this.idClientSelected;
        } else {
          filter.internalEquipment = true;
        }
      }
    }

    this.internalEquipmentService.findAutocomplete(filter).pipe(takeUntil(this.destroy$)).subscribe(item => {
      results = item.content;
      this.equipmentAutoComplete = results;
    }, () => {
      results = [];
      this.equipmentAutoComplete = results;
    });
  }

  onSensorChange($event: any, trigger: MatAutocompleteTrigger): void {
    const equipmentSelected = $event.option.value as InternalEquipment;
    this.onEquipmentChange(equipmentSelected);
    trigger.closePanel();
  }

  createEquipment(): void {
    this.dialog.open(CalibrationBalanceEditCreateEquipmentComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        idType: this.idClientSelected === -1 ? CalibrationBalanceResponsibleEnum.INTERNAL : CalibrationBalanceResponsibleEnum.EXTERNAL,
        idClient: this.idClientSelected === -1 ? null : this.idClientSelected,
        idEquipmentType: InternalEquipmentTypeEnum.BALANCES.id
      }
    });
  }

  userCanModify(): boolean {
    const profile = this.userService.currentProfile;

    if (profile == null || this.calibration.idStatus === CalibrationBalanceStatus.NO_VALIDO) {
      return false;
    }

    return true;
  }


  showInvalidate(): boolean {
    return this.calibration.id != null && this.calibration.idStatus !== CalibrationBalanceStatus.NO_VALIDO;
  }

  invalidate(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: this.translate.instant('calibrateEquipmentEdit.form.invalidate.confirm') as string
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result === true) {
        this.requestReason((reason) => {

          const dialogPass = this.dialog.open(ActionConfirmPasswordComponent, {
            minWidth: '20%',
            maxHeight: '95vh',
            data: {}
          });

          dialogPass.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {
            if (token != null) {
              this.spinnerService.show();

              this.calibrationBalanceService.invalidate(this.calibration.id, token, reason).pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.spinnerService.hide();
                this.reloadPage(this.calibration.id);
              }, error => {
                if (error != null && error.error != null && typeof error.error === 'string') {
                  this.snackBarService.sendError(error.error as string);
                } else {
                  this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.status.back.error.generic') as string);
                }
                this.spinnerService.hide();
              });
            }
          }, error => {
            if (error != null && error.error != null && typeof error.error === 'string') {
              this.snackBarService.sendError(error.error as string);
            } else {
              this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.status.back.error.generic') as string);
            }
          });
        });
      }
    });
  }

  onChangeVariableCheck(event: MatOptionSelectionChange): void {
    if (!event.isUserInput) {
      return;
    }

    const variable = event.source.value as Variable;

    if (this.calibration.variables == null) {
      this.calibration.variables = [];
    }

    if (event.source.selected) {
      const tab = new CalibrationBalanceVariable();
      tab.idVariable = variable.id;
      tab.variableTranslation = variable.translation;

      this.calibration.variables.push(tab);
    } else {
      this.calibration.variables = this.calibration.variables.filter(item => item.idVariable !== variable.id);
    }
  }
  
  private performSave() {
    if (this.calibration.id == null) {
      this.save(true);
    } else {
      const showReason = +this.calibration.signedVersion !== 0;

      if (!showReason) {
        this.save(false);
        return;
      }

      const dialogRef = this.dialog.open(CalibrationBalanceEditConfirmSaveComponent, {
        minWidth: '30vw',
        data: {
          calibration: this.calibration,
          reason: this.calibration.reason,
          showReason
        }
      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: DialogDataConfirmSave) => {
        if (result != null) {

          if (result.showReason) {
            this.calibration.reason = result.reason;
          }

          this.save(false);
        }
      });

    }

  }

  onEssayTabChange(indexVariable: number, event: MatTabChangeEvent | number): void {
    let index: number;

    if (event instanceof MatTabChangeEvent) {
      index = event.index;
    } else {
      index = event;
    }

    const tab = this.calibration.variables[indexVariable].essays[index];
  }


  onChangeEssayCheck(indexVariable: number, event: MatOptionSelectionChange): void {
    if (!event.isUserInput) {
      return;
    }

    const idBalanceEssayType = event.source.value as number;

    const balanceEssayType = this.balanceEssayTypes.find(e => e.id === idBalanceEssayType);
    if (this.calibration.variables[indexVariable].essays == null) {
      this.calibration.variables[indexVariable].essays = [];
    }

    if (event.source.selected) {
      const tab = new CalibrationBalanceVariableEssay();
      tab.idEssayType = balanceEssayType.id;
      tab.essayTranslation = balanceEssayType.translation;
      tab.uuidConfig = uuid();

      tab.asLeft = [];
     
      if (idBalanceEssayType === BalanceEssayTypeEnum.ESSAY_ECCENTRICITY) {
        let i = 0;
        while (i < 5) {
          const asLeftEcc = new CalibrationBalanceEssayAsLeft();
          asLeftEcc.point = i;
          asLeftEcc.pattern = i;
          tab.asLeft.push(asLeftEcc);
          i++;
        }
      
        const idUnit = this.calibration.variables[indexVariable]?.idUnit;
        
        const equipments = this.calibration?.variables?.[indexVariable]?.patterns?.reduce<InternalEquipment[]>((acc, { equipment }) => acc.concat(equipment), []) ?? [];
        if (equipments?.length > 0) {
          /*CalibrationBalanceUtils.getBalanceMassByUnit(equipments, idUnit).forEach(item => {
            item.balanceMass.forEach(bm => this.essayLoad.push(bm));
          });*/
        }
        this.updateTable(this.asLeftTableEccentricity);
      } else if (idBalanceEssayType === BalanceEssayTypeEnum.ESSAY_MINIMUM_WEIGHT) {
         const essayRep = this.calibration.variables[indexVariable].essays.find(eess => eess.idEssayType === BalanceEssayTypeEnum.ESSAY_REPEATABILTY);

         if (essayRep) {
          essayRep.asLeft.forEach(eas => {
            const asLeftEcc = new CalibrationBalanceEssayAsLeft();
            asLeftEcc.point = eas.point;
            asLeftEcc.pattern = eas.pattern;
            asLeftEcc.uuidConfig = eas.uuidConfig;
            tab.asLeft.push(asLeftEcc);
          });
          this.updateTable(this.asLeftTableMinimumWeight);
         }
      }
      this.calibration.variables[indexVariable].essays.push(tab);
    } else {
      this.calibration.variables[indexVariable].essays = this.calibration.variables[indexVariable].essays.filter(item => item.idEssayType !== balanceEssayType.id);
    }
  }

   onUnitChange(indexVariable: number, event: MatSelectChange | VariableUnit): void {
    const variable = this.calibration.variables[indexVariable];

    let unit: VariableUnit;

    if (event instanceof MatSelectChange) {
      unit = this.variableUnits.find(v => v.id === event.value);
    } else {
      unit = event;
    }

    if (variable != null && unit != null) {
      variable.idUnit = unit.id;
      variable.unitName = unit.unit;

      this.calibration.variables[indexVariable] = variable;
    }
  }

   async onVariableTabChange(event: MatTabChangeEvent | number): Promise<void> {
    let index: number;

    if (event instanceof MatTabChangeEvent) {
      index = event.index;
    } else {
      index = event;
    }

    if (!this.calibration.variables) {
      return;
    }

    const tab = this.calibration.variables[index];

    this.variableUnits = [];
    this.variableUnitsExtra = [];

    if (tab != null && tab.idVariable != null) {
       this.variableTypeService.findUnits(tab.idVariable).pipe(takeUntil(this.destroy$)).subscribe((res: VariableUnit[]) => {
        this.variableUnits = res?.sort((a, b) => a.id - b.id);

        if (tab.idUnit == null || !this.variableUnits.map(v => v.id).includes(tab.idUnit)) {
          this.onUnitChange(index, res[0]);
        }
        if (tab.idUnitInput == null || !this.variableUnits.map(v => v.id).includes(tab.idUnitInput)) {
          tab.idUnitInput = tab.idUnit;
        }
      });

      if (tab.idVariable === VariableTypeEnum.SPEED) {
        this.variableTypeService.findUnits(VariableTypeEnum.DIMENSIONAL).pipe(takeUntil(this.destroy$)).subscribe((res: VariableUnit[]) => {
          this.variableUnitsExtra = res;

          if (tab.idUnitExtra == null || !this.variableUnitsExtra.map(v => v.id).includes(tab.idUnitExtra)) {
            tab.idUnitExtra = this.variableUnitsExtra[0]?.id;
          }
        });
      }

      if (!tab.essays || tab.essays.length === 0) {
        const essay = new CalibrationBalanceVariableEssay();
        essay.idEssayType = BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL;
        essay.essayTranslation = this.balanceEssayTypes.find(be => be.id ===  BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL).translation;
        essay.uuidConfig = uuid();

        essay.asLeft = [];

        const essayRep = new CalibrationBalanceVariableEssay();
        essayRep.idEssayType = BalanceEssayTypeEnum.ESSAY_REPEATABILTY;
        essayRep.essayTranslation = this.balanceEssayTypes.find(be => be.id ===  BalanceEssayTypeEnum.ESSAY_REPEATABILTY).translation;
        essayRep.uuidConfig = uuid();

        if (!tab.essays) {
          tab.essays = [];
        }

        tab.essays.push(essay);
        tab.essays.push(essayRep);

        const essayEcc = new CalibrationBalanceVariableEssay();
        essayEcc.idEssayType = BalanceEssayTypeEnum.ESSAY_ECCENTRICITY;
        essayEcc.essayTranslation = this.balanceEssayTypes.find(be => be.id ===  BalanceEssayTypeEnum.ESSAY_ECCENTRICITY).translation;
        essayEcc.uuidConfig = uuid();

        let i = 0;
        essayEcc.asLeft = [];
        while (i < 5) {
          const asLeftEcc = new CalibrationBalanceEssayAsLeft();
          asLeftEcc.point = i;
          asLeftEcc.pattern = i;
          essayEcc.asLeft.push(asLeftEcc);
          i++;
        }

        tab.essays.push(essayEcc);

        tab.idsEssayType = [];
        tab.idsEssayType.push(BalanceEssayTypeEnum.ESSAY_ECCENTRICITY);
        tab.idsEssayType.push(BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL);
        tab.idsEssayType.push(BalanceEssayTypeEnum.ESSAY_REPEATABILTY);
      }
      
      const equipments = tab?.patterns?.reduce<InternalEquipment[]>((acc, { equipment }) => acc.concat(equipment), []) ?? [];
      if (equipments?.length > 0) {
        this.vBalanceMass = [];
        await Promise.all(
          (equipments ?? []).map(element =>
            this.getBalanceMass(index, element.id)
          )
        );
      }
    }
  }

  editConfigRow(idVariable: number, index: number): void {
    const calibration = this.calibration.variables[idVariable];

    const row = calibration.configs[index];

    const dialogRef = this.dialog.open(CalibrationBalanceEditConfigDialogComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        item: _.cloneDeep(row)
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: CalibrationBalanceVariableConfig) => {
      if (result != null) {
        this.calibration.variables[idVariable].configs[index] = result;

        this.calibration.variables[idVariable].essays.forEach((essay) => {
          if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL) {
            const pointsNumbers = result.points.map(Number);
            const asLeft = _.cloneDeep(essay.asLeft);
            essay.asLeft = [];
            essay.asLeft = asLeft.filter(lp => lp.uuidConfig === result.uuidConfig && pointsNumbers.includes(Number(lp.point)));
          
            result.points.forEach((rv, rvIndex) => {
              if (essay.asLeft[rvIndex]) {
                  essay.asLeft[rvIndex].point = rv;
              } else {
                const pointLetf = new CalibrationBalanceEssayAsLeft();
                pointLetf.point = rv;
                pointLetf.uuidConfig = result.uuidConfig;
                if (!essay.asLeft) {
                  essay.asLeft = [];
                }
                
                essay.asLeft.push(pointLetf);
                essay.asLeft?.sort((a, b) => (a.point > b.point) ? 1 : ((b.point > a.point) ? -1 : 0));
              }
            });
          }

          if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_REPEATABILTY) {
            const existValueRep = essay.asLeft?.every(el => el.values && el.values?.length > 0);

            if (!existValueRep) {
              const pointsNumbers = result.points.map(Number);
              const asLeft = _.cloneDeep(essay.asLeft);
              essay.asLeft = [];
              essay.asLeft = asLeft.filter(lp => lp.uuidConfig === result.uuidConfig && pointsNumbers.includes(Number(lp.point)));
          
              result.points.forEach((rv, rvIndex) => {
                if (essay.asLeft[rvIndex]) {
                  essay.asLeft[rvIndex].point = rv;
                } else {
                  const pointLetf = new CalibrationBalanceEssayAsLeft();
                  pointLetf.point = rv;
                  pointLetf.uuidConfig = result.uuidConfig;
                  if (!essay.asLeft) {
                    essay.asLeft = [];
                  }
                  
                  essay.asLeft.push(pointLetf);
                  essay.asLeft?.sort((a, b) => (a.point > b.point) ? 1 : ((b.point > a.point) ? -1 : 0));
                }
              });

            }
          }
        });
        this.calculateResult();
        this.updateTable(this.configTables);
        this.updateTable(this.patternsTables);
        this.updateTable(this.asLeftTables);
        this.updateTable(this.asLeftRepetibilityTables);
        this.updateTable(this.asLeftTableEccentricity);
        this.updateTable(this.uncertaintiesTable);
      }
    });
  }

  calculateResult(): void {
    const configs = [].concat(...this.calibration.variables.filter(v => v.configs != null).map(v => v.configs)) as CalibrationBalanceVariableConfig[];

    const tolerances = configs.map(c => +c.tolerance).filter(v => v != null && !isNaN(v) && v !== 0);

    if (!ArrayUtils.isEmpty(tolerances)) {
      let res = true;

      this.calibration.variables?.forEach((variable, vIndex) => {

        variable.essays.forEach(c => {
          if (c.asLeft?.length > 0) {
            const styles = c.asLeft.map(aL => {
              //aL.recalculateValues();
              return this.styleCPlusU(vIndex, aL.point, aL.cPlusU);
            }).filter(v => v != null && v === 'validValue');

            res = res && (styles.length === c.asLeft.length);
          }
        })
      });

      this.calibration.correct = res;
    } else {
      this.calibration.correct = true;
    }
  }

  styleCPlusU(indexVariable: number, point: number, value: number): string {
    let res = '';

    const config = this.findConfig(indexVariable, point);
    if (config == null) {
      return res;
    }

    const tolerance = config.tolerance;

    if (tolerance == null || isNaN(+tolerance) || +tolerance === 0) {
      return res;
    }

    res = (+tolerance) < value ? 'invalidValue' : 'validValue';
    return res;
  }

  newConfigRow(idVariable: number): void {
    const variable = this.calibration.variables[idVariable];

    const dialogRef = this.dialog.open(CalibrationBalanceEditConfigDialogComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        item: new CalibrationBalanceVariableConfig()
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: CalibrationBalanceVariableConfig) => {

      if (result != null) {
        if (!this.calibration.variables[idVariable].configs) {
          this.calibration.variables[idVariable].configs = [];
        }
        
        this.calibration.variables[idVariable].configs?.push(result);

        variable.essays.forEach((essay) => {
          if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL) {
            result.points.forEach(rv => {
              const pointLetf = new CalibrationBalanceEssayAsLeft();
              pointLetf.point = rv;
              pointLetf.uuidConfig = result.uuidConfig;
              if (!essay.asLeft) {
                essay.asLeft = [];
              }
              
              essay.asLeft.push(pointLetf);
            });
          }

          if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_REPEATABILTY) {
            const existValueRep = essay.asLeft?.every(el => el.values && el.values?.length > 0);

            if (!existValueRep) {
              result.points.forEach(rv => {
                const pointLetf = new CalibrationBalanceEssayAsLeft();
                pointLetf.point = rv;
                pointLetf.uuidConfig = result.uuidConfig;
                if (!essay.asLeft) {
                  essay.asLeft = [];
                }
                essay.asLeft.push(pointLetf);
              });
            }
            
          }
        });
        this.calculateResult();
        this.updateTable(this.configTables);
        this.updateTable(this.patternsTables);
      }
    });
  }
  
  newPatternRow(idVariable: number): void {
    const variable = this.calibration.variables[idVariable];

    const configs = variable.configs;

    const dialogRef = this.dialog.open(CalibrationBalanceEditPatternsDialogComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        item: new CalibrationBalancePattern(),
        variable,
        configs,
        units: this.variableUnits
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(async (result: CalibrationBalancePattern) => {

      if (result != null) {
        variable.patterns.push(result);
        this.vBalanceMass = [];

        variable.essays.forEach((essay) => {
          if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL) {
            result.values.forEach(rv => {
              let pointLetf = essay.asLeft.find(al => al.point === rv.value && al.uuidConfig === rv.uuidConfig);
              pointLetf.point = rv.value;
              pointLetf.uuidPattern = result.uuidPattern;
              pointLetf.pattern = rv.nominal;
              pointLetf.uncertaintyTypical = rv.uncertainty;
              pointLetf.decimalPattern = rv.decimalPattern;

              const indexPointLetf = essay.asLeft.findIndex(al => al.point === rv.value && al.uuidConfig === rv.uuidConfig);

              essay.asLeft[indexPointLetf] = pointLetf;
              essay.asLeft?.sort((a, b) => (a.point > b.point) ? 1 : ((b.point > a.point) ? -1 : 0));
            });
          }

          if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_REPEATABILTY) {
             const existValueRep = essay.asLeft?.every(el => el.values && el.values?.length > 0);

             if (!existValueRep) {
                result.values.forEach(rv => {
                  let pointLetf = essay.asLeft.find(al => al.point === rv.value && al.uuidConfig === rv.uuidConfig);
                  if (pointLetf) {
                    pointLetf.point = rv.value;
                    pointLetf.uuidPattern = result.uuidPattern;
                    pointLetf.pattern = rv.nominal;
                    pointLetf.uncertaintyTypical = rv.uncertainty;
                    pointLetf.decimalPattern = rv.decimalPattern;
                    const indexPointLetf = essay.asLeft.findIndex(al => al.point === rv.value && al.uuidConfig === rv.uuidConfig);

                    essay.asLeft[indexPointLetf] = pointLetf;
                    essay.asLeft?.sort((a, b) => (a.point > b.point) ? 1 : ((b.point > a.point) ? -1 : 0));
                  }
                });
             }
          }
        });


        this.calculateResult();
        this.updateTable(this.configTables);
        this.updateTable(this.patternsTables);
        this.updateTable(this.asLeftTables);
        this.updateTable(this.asLeftRepetibilityTables);
        this.updateTable(this.asLeftTableEccentricity);
        this.updateTable(this.uncertaintiesTable);

        await Promise.all(
          (result.idEquipment ?? []).map(element =>
            this.getBalanceMass(idVariable, element)
          )
        );
      }
    });
  }

  editPatternRow(idVariable: number, index: number, indexEssay: number): void {
    const variable = this.calibration.variables[idVariable];

    const row = variable.patterns[index];

    const configs = variable.configs;

    const dialogRef = this.dialog.open(CalibrationBalanceEditPatternsDialogComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        item: _.cloneDeep(row),
        variable,
        configs,
        units: this.variableUnits
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(async (result: CalibrationBalancePattern) => {

      if (result != null) {
        variable.patterns[index] = result;
        //this.configurateAsLeft(idVariable, indexEssay);

        variable.essays.forEach((essay) => {
          if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL) {
            result.values.forEach(rv => {
              let pointLetf =  essay.asLeft.find(al => Number(al.point) === Number(rv.value) && al.uuidConfig === rv.uuidConfig);
              if (pointLetf) {
                pointLetf.point = rv.value;
                pointLetf.uuidPattern = result.uuidPattern;
                pointLetf.pattern = rv.nominal;
                pointLetf.uncertaintyTypical = rv.uncertainty;
                pointLetf.decimalPattern = rv.decimalPattern;

                const indexPointLetf = essay.asLeft.findIndex(al => Number(al.point) === Number(rv.value) && al.uuidConfig === rv.uuidConfig);

                essay.asLeft[indexPointLetf] = pointLetf;
                essay.asLeft?.sort((a, b) => (a.point > b.point) ? 1 : ((b.point > a.point) ? -1 : 0));
                this.calibration.variables[idVariable].essays[indexEssay] = essay;
                this.updateTable(this.asLeftTables);
              }
            });
          }

          if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_REPEATABILTY) {
            result.values.forEach(rv => {
                let pointLetf = essay.asLeft.find(al => Number(al.point) === Number(rv.value) && al.uuidConfig === rv.uuidConfig);
                if (pointLetf) {
                  pointLetf.point = rv.value;
                  pointLetf.uuidPattern = result.uuidPattern;
                  pointLetf.pattern = rv.nominal;
                  pointLetf.uncertaintyTypical = rv.uncertainty;
                  pointLetf.decimalPattern = rv.decimalPattern
                  const indexPointLetf = essay.asLeft.findIndex(al => Number(al.point) === Number(rv.value) && al.uuidConfig === rv.uuidConfig);

                  essay.asLeft[indexPointLetf] = pointLetf;
                  essay.asLeft?.sort((a, b) => (a.point > b.point) ? 1 : ((b.point > a.point) ? -1 : 0));
                  this.updateTable(this.asLeftRepetibilityTables);
                }
              });
            }
        });

        await Promise.all(
          (result.idEquipment ?? []).map(element =>
            this.getBalanceMass(idVariable, element)
          )
        );

        this.calculateResult();
        this.updateTable(this.configTables);
        this.updateTable(this.asLeftTables);
        this.updateTable(this.patternsTables);
        this.updateTable(this.asLeftTableEccentricity);
        this.updateTable(this.uncertaintiesTable);
      }
    });
  }

  deletePatternRow(idVariable: number, index: number): void {
    const calibration = this.calibration.variables[idVariable];

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: this.translate.instant('calibrateEquipmentEdit.form.deletePattern.confirm') as string
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result === true) {
        const pattern = calibration.patterns[index];
        calibration.patterns.splice(index, 1);
        calibration.essays?.forEach(es => {
          if (es.idEssayType !== BalanceEssayTypeEnum.ESSAY_ECCENTRICITY) {
            if (es.asLeft?.length > 0) {
              const resAsleft = es.asLeft?.filter(esl => esl.uuidPattern === pattern.uuidPattern);

              if (resAsleft) {
                resAsleft.forEach(pointLetf => {
                  pointLetf.uuidPattern = null;
                  pointLetf.uncertaintyTypical = null;
                  pointLetf.values = [];
                  pointLetf.average = null;
                  pointLetf.correction = null;
                  pointLetf.devesta = null;
                  pointLetf.spm = null;
                  pointLetf.pMResult = null;
                  pointLetf.resolution = null;
                  pointLetf.k = null;
                  pointLetf.neff = null;
                  pointLetf.cPlusU = null;
                  pointLetf.uResol = null;
                  pointLetf.uUnif = null;
                  pointLetf.uC = null;
                  pointLetf.uExc = null;
                  pointLetf.U = null;
                });
              }
            }
          }
        });
        this.updateTable(this.configTables);
        this.updateTable(this.asLeftTables);
        this.updateTable(this.patternsTables);
        this.updateTable(this.asLeftRepetibilityTables);
        this.updateTable(this.asLeftTableEccentricity);
        this.updateTable(this.uncertaintiesTable);
      }
    });
  }

  showConfigPoints(points: number[]): string {
    return points?.join(",");
  }
 
  editAsLeftRow(indexVariable: number, indexEssay: number, index: number): void {
    const variable = this.calibration.variables[indexVariable];
    const essay = variable.essays[indexEssay];

    const row = essay.asLeft[index];
    const rowIndex = essay.asLeft.indexOf(row);

    const emptyList: CalibrationBalanceEssayAsLeft[] = [];
    const asLeftList = emptyList.concat(...essay.asLeft);
    const minValues = Math.max(...asLeftList.map(aL => ArrayUtils.isEmpty(aL.values) ? 0 : aL.values.length));

    const dialogRef = this.dialog.open(CalibrationBalanceEditAsLeftDialogComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        item: _.cloneDeep(essay.asLeft[rowIndex]),
        minValues,
        idEssayType: essay.idEssayType
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: CalibrationBalanceEssayAsLeft) => {

      if (result != null) {
        this.calibration.variables[indexVariable].essays[indexEssay].asLeft[rowIndex] = result;

        this.calculateResult();

        this.updateTable(this.configTables);
        if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL) {
          this.recalculateValues(indexVariable, indexEssay, rowIndex, result.values,  result.resolution, result.patterns);
          this.updateTable(this.asLeftTables);
        } if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_ECCENTRICITY) {
        const essayEcc = this.calibration.variables[indexVariable].essays?.find(vs => vs.idEssayType === BalanceEssayTypeEnum.ESSAY_ECCENTRICITY);
          this.configurateAsLeft(indexVariable, indexEssay);
          this.updateTable(this.asLeftTableEccentricity);
          this.updateTable(this.uncertaintiesTable);
        } if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_REPEATABILTY) {
          let essay = variable.essays.find(eef => eef.idEssayType === BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL);
          let rowIndexFundamental = variable.essays.findIndex(eef => eef.idEssayType === BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL);
          const resValues = _.cloneDeep(result.values);
          const asLeftFund = essay.asLeft.find(el => Number(el.point) === Number(result.point));
          const asLeftFundIndex =  essay.asLeft.findIndex(el => Number(el.point) === Number(result.point));
          let asleft = _.cloneDeep(asLeftFund);
          asleft.values = [];
          resValues.forEach(rvv => {
            rvv.id = null;
            rvv.idAsLeft = asleft.id;
           
            asleft.values.push(rvv);
          });
          this.calibration.variables[indexVariable].essays[rowIndexFundamental].asLeft[asLeftFundIndex] = asleft;
          this.recalculateValues(indexVariable, rowIndexFundamental, asLeftFundIndex, asleft.values,  asleft.resolution, asleft.patterns);
          this.configurateAsLeft(indexVariable, indexEssay);
          this.updateTable(this.asLeftTables);
          this.updateTable(this.asLeftRepetibilityTables);
          this.updateTable(this.asLeftTableEccentricity);
          this.updateTable(this.uncertaintiesTable);
          
        }
        this.updateTable(this.patternsTables);
      }
    });
  }

  joinListValues(idVariable: number, item: CalibrationBalanceEssayAsLeft): string {
    if (ArrayUtils.isEmpty(item.values)) {
      return '';
    }

    const array: number[] = item.values.map(v => v.value);

    const totalDecimals = this.getDecimalsResolution(idVariable, item.point);

    return this.joinList(array, totalDecimals);
  }

  getDecimalsResolution(idVariable: number, point: number): number {
    const config = this.findConfig(idVariable, point);

    return this.getDecimalsResolutionConfig(config);
  }

  getDecimalsResolutionConfig(config: CalibrationBalanceVariableConfig): number {
    let res = 2;
    if (config != null) {
      const resolution = config.resolution;
      if (resolution === 1) {
        res = 0;
      } else {
        res = NumberUtils.countDecimals(resolution);
      }
    }

    return res;
  }

  getDecimalsPattern(pattern: number): number {
    return NumberUtils.countDecimals(pattern);
  }

  getDevestaValue(item: CalibrationBalanceEssayAsLeft): number {
    if (ArrayUtils.isEmpty(item.values)) {
      return null;
    }
    const data = item.values.map(v => v.value);
    return CalibrationBalanceUtils.desvesta(data);
  }

  getAsLeftList(indexVariable: number): CalibrationBalanceEssayAsLeft[] {
    const res: CalibrationBalanceEssayAsLeft[] = [];
    
    if (this.calibration.variables[indexVariable]?.essays) {
      const resEssay = this.calibration.variables[indexVariable].essays?.find(ve => ve.idEssayType === BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL);
      if (resEssay) {
        resEssay.asLeft?.forEach(aL => {
        const cfg = this.findConfig(indexVariable, aL.point);
        
        const instance = Object.assign(new CalibrationBalanceEssayAsLeft(),{ ...aL, values: aL.values});
         if (cfg != null) {
            instance.resolution = cfg.resolution;
            aL.values?.find(elv => {
              elv.value
            });
          }

          res.push(instance);
        });
      }
      
    }

    return res.sort((a1, a2) => a1.id - a2.id);
  }

  getEquipmentMaker(equipment: InternalEquipment[], type: number): string {
    if (!equipment || equipment?.length === 0) {
      return '-';
    }

    switch (type) {
      case 1:
        return equipment.map(e => {
          if (!e) {
            return '-';
          }
          return e.name ? e.name : '-';
        }).join(", ");
      case 2:
        return equipment.map(e => {
          if (!e) {
            return '-';
          }
          return e.equipment ? e.equipment : '-';
        }).join(", ");
      case 3:
        return equipment.map(e => {
          if (!e) {
            return '-';
          }
          return e.maker ? e.maker : '-';
        }).join(", ");
      case 4:
        return equipment.map(e => {
          if (!e) {
            return '-';
          }
          return e.model ? e.model : '-';
        }).join(", ");
      case 5:
        return equipment.map(e => {
          if (!e) {
            return '-';
          }
          return e.serialNum ? e.serialNum : '-';
        }).join(", ");
      default:
        break;
    }
  }

  getErrorNominal(essay: CalibrationBalanceVariableEssay): number {
    const nominal = essay.essayLoad;

    if (nominal && essay?.asLeft?.length > 0) {
      const diffs = essay?.asLeft?.map(e => 
        e.values?.length > 0 ? Math.abs(e.values[0]?.value - nominal) : 0
      );

      return Math.max(...diffs);
    } else {
      return 0;
    }
  }

  getCalculateEssayTara(essay: CalibrationBalanceVariableEssay) {
    if (!essay) {
      return 0;
    }
    essay.grossWeight =  Math.round(Number(Math.round(essay.essayPreload) ?? 0) + Number(Math.round(essay.essayLoad) ?? 0));
    essay.error =  Number(essay.essayLoadRead ?? 0) - Number(essay.essayLoad ?? 0);
  }

  getErrorCenter(essay: CalibrationBalanceVariableEssay): number {
    const center = essay.asLeft?.find(pe => pe.point === 0);
    if (center && essay.asLeft?.length > 0) {
       const diffs = essay.asLeft?.map(e => 
         e.values?.length > 0 ? Math.abs(e.values[0]?.value - center.values[0]?.value) : 0
      );

      return Math.max(...diffs);
    } else {
      return 0;
    }
  }

  onChangeDisableEssay(idEssay: number): boolean {
    return idEssay === BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL || idEssay === BalanceEssayTypeEnum.ESSAY_REPEATABILTY; 
  }


  private joinList(list: number[], totalDecimals: number): string {
    let res: string = null;

    if (!ArrayUtils.isEmpty(list)) {
      res = list.filter(d => d != null).map(d => d.toFixed(totalDecimals)).join(', ');
    }

    return res;
  }

  private findConfig(indexVariable: number, point: number): CalibrationBalanceVariableConfig {
    const configs = this.calibration.variables[indexVariable]?.configs;

    let config: CalibrationBalanceVariableConfig = null;

    if (!ArrayUtils.isEmpty(configs)) {
      if (point != null) {
        config = configs.find(c => NumberUtils.isBetweenEq(point, c.rangeInit, c.rangeEnd));
      }

      if (config == null && point != null) {
        config = configs.find(c => c.points.includes(point));
      }

      if (config == null) {
        config = configs[0];
      }
    }

    return config;
  }

  configurateAsLeft(indexVariable: number, indexEssay: number): void {
    const variable = this.calibration.variables[indexVariable];
    let diffCenter = 0;
      
    variable?.essays[indexEssay]?.asLeft?.forEach((aL, indexLeft) => {
      const cfg = this.findConfig(indexVariable, aL.point);

      if (cfg != null) {
        aL.resolution = cfg.resolution;
      }

      const patterns = variable.patterns?.map(p => {
        if (ArrayUtils.isEmpty(p.values)) {
          return null;
        }

        const res = p.values?.filter(point => point.value === Number(aL.point));

        if (ArrayUtils.isEmpty(res)) {
          return null;
        } else {
          return res[0];
        }

      })?.filter(p => p != null).map(p => p.uncertainty);
      
      aL.patterns = patterns;

      this.recalculateValues(indexVariable, indexEssay, indexLeft, aL.values,  aL.resolution, aL.patterns);

      let asLeft = this.calibration.variables[indexVariable].essays[indexEssay].asLeft[indexLeft];
      const essayRepet = this.calibration.variables[indexVariable].essays?.find(vs => vs.idEssayType === BalanceEssayTypeEnum.ESSAY_REPEATABILTY);

      asLeft.uHister = null;
      if (essayRepet && essayRepet.asLeft) {
        const dataPattern = [].concat(...essayRepet.asLeft.filter(esl => esl.pattern === asLeft.pattern).map(esl => esl.values.map(v => v.value)));        
        asLeft.uHister = this.calcularUHist(dataPattern);
      }
      
      const essayFundamental = this.calibration.variables[indexVariable].essays?.find(vs => vs.idEssayType === BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL);

      const essayEcc = this.calibration.variables[indexVariable].essays?.find(vs => vs.idEssayType === BalanceEssayTypeEnum.ESSAY_ECCENTRICITY);
      if (essayEcc && essayEcc.asLeft) {
        diffCenter = this.getErrorCenter(essayEcc);
         essayFundamental.asLeft?.forEach(asF => {
          asF.uExc = (asF.point * (diffCenter ?? 0)) / ((essayEcc.essayLoad ?? 0) * Math.sqrt(12))
        })
      }
      
      this.updateTable(this.asLeftTables);
      this.updateTable(this.asLeftRepetibilityTables);
      this.updateTable(this.asLeftTableEccentricity);
      this.updateTable(this.uncertaintiesTable);
    });
  }

  getDecimalsUncertainty(idVariable: number, point: number): number {
    const config = this.findConfig(idVariable, point);

    let res = 2;

    if (config != null) {
      const uncertaintyResolution = config.uncertaintyResolution;
      const uncertaintyDecimals = NumberUtils.countDecimals(uncertaintyResolution);

      if (uncertaintyDecimals === 0) {
        res = uncertaintyResolution;
      } else {
        res = uncertaintyDecimals;
      }
    }

    return res;
  }

  joinListUP(idVariable: number, item: CalibrationBalanceEssayAsLeft): string {
    if (ArrayUtils.isEmpty(item.patterns)) {
      return '';
    }

    const array: number[] = item.patterns;

    const totalDecimals = this.getDecimalsUncertainty(idVariable, item.point);

    return this.joinList(array, totalDecimals);
  }

  getWorstUncertainty(indexVariable: number, item: CalibrationBalancePattern,): any {
    if (ArrayUtils.isEmpty(item.values)) {
      return null;
    }

      const config = this.findUuidConfig(indexVariable,item.uuidConfig);

      const uncertaintyResolution = config.uncertaintyResolution;
      const uncertaintyDecimals = NumberUtils.countDecimals(uncertaintyResolution);
      let totalDecimals = 2;
      if (uncertaintyDecimals === 0) {
        totalDecimals = Number(uncertaintyResolution);
      } else {
        totalDecimals = uncertaintyDecimals;
      }

      return Math.max(...item.values.map(v =>  NumberUtils.toNumberDecimals(v.uncertainty, totalDecimals)));

  }

  getGrossWeightTara(essay: CalibrationBalanceVariableEssay): number {
    if (essay) {
      if (essay.essayPreload && essay.essayLoad) {
        return essay.essayPreload + essay.essayLoad;
      } else {
        return 0;
      }
    }
  }

  onEssayData(indexVariable: number, essay: CalibrationBalanceVariableEssay) {
      let points = [];
      let uuidPattern = null;
      if (this.calibration.variables[indexVariable].patterns?.length > 0) {
        uuidPattern = this.calibration.variables[indexVariable].patterns[0].uuidPattern;
      }
      if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_MINIMUM_WEIGHT) {
        const essayRep = this.calibration.variables[indexVariable].essays.find(cm => cm.idEssayType === BalanceEssayTypeEnum.ESSAY_REPEATABILTY);
       
        if (!essayRep) {
          return;
        } else {
          points = this.calibration.variables[indexVariable].configs.map(cm => ({
            uuidConfig: cm.uuidConfig,
            uuidPattern: uuidPattern,
            points: cm.points.filter(epf => essayRep.asLeft.some(ele => Number(ele.point) === Number(epf)))
          }));
        }
      } else {
        points = this.calibration.variables[indexVariable].configs.map(cm => ({
          uuidConfig: cm.uuidConfig,
          uuidPattern: uuidPattern,
          points: cm.points
        }));
      }

      const patterns = this.calibration.variables[indexVariable].patterns;
      
      let pointsSelect = [];

     if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_REPEATABILTY) {
      if (essay.asLeft) {
        pointsSelect = essay.asLeft.map(cm => ({
          uuidConfig: cm.uuidConfig,
          uuidPattern: cm.uuidPattern,
          point: cm.point
        }));
      } 
     } else if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_MINIMUM_WEIGHT) {
      if (essay.asLeft) {
        pointsSelect = essay.asLeft.map(cm => ({
          uuidConfig: cm.uuidConfig,
          uuidPattern: cm.uuidPattern,
          point: cm.point
        }));
      }
     } 

     const dialogRef = this.dialog.open(CalibrationBalanceEditSelectPointsComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {
        points,
        pointsSelect,
        isAsFound: false
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((res: CalibrationBalanceVariablePoints[]) => {
      if (res?.length > 0) {

        if (essay.asLeft) {
          essay.asLeft = essay.asLeft.filter(eas =>
            res.some(esl => Number(eas.point) === Number(esl.value) && eas.uuidConfig === esl.uuidConfig)
          );
        } else {
           essay.asLeft = [];
        }
        
        for (const rf of res) {
          const exists = essay.asLeft?.some(esl => Number(esl.point) === Number(rf.value) && esl.uuidConfig === rf.uuidConfig);

          if (!exists) {
            const newLeft = new CalibrationBalanceEssayAsLeft();
            newLeft.point = rf.value;
            newLeft.uuidConfig = rf.uuidConfig;
            newLeft.uuidPattern = rf.uuidPattern;
            const resPattern = patterns.find(ep => ep.uuidConfig === rf.uuidConfig);;
            const resValues = resPattern.values.find(epv => Number(epv.value) === Number(rf.value));
            newLeft.pattern = resValues.nominal;
            newLeft.uncertaintyTypical = resValues.uncertainty;

            essay.asLeft.push(newLeft);
          }
        }

        if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_MINIMUM_WEIGHT) {
          this.onBlurSpm(indexVariable, essay);
        }
        this.updateTable(this.asLeftRepetibilityTables);
      }
    });
  }

   onEssayDataAsFound(indexVariable: number, essay: CalibrationBalanceVariableEssay) {
      let points = [];
      let uuidPattern = null;
      if (this.calibration.variables[indexVariable].patterns?.length > 0) {
        uuidPattern = this.calibration.variables[indexVariable].patterns[0].uuidPattern;
      }
      
      points = this.calibration.variables[indexVariable].configs.map(cm => ({
        uuidConfig: cm.uuidConfig,
        uuidPattern: uuidPattern,
        points: cm.points
      }));

      const patterns = this.calibration.variables[indexVariable].patterns;
      
      let pointsSelect = [];

      pointsSelect = essay.asFound?.map(cm => ({
        uuidConfig: cm.uuidConfig,
        uuidPattern: cm.uuidPattern,
        point: cm.point
      }));

     const dialogRef = this.dialog.open(CalibrationBalanceEditSelectPointsComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {
        points,
        pointsSelect:  pointsSelect ?? [],
        isAsFound: true
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((res: CalibrationBalanceVariablePoints[]) => {
      if (res?.length > 0) {

        if (essay.asFound) {
          essay.asFound = essay.asFound.filter(eas =>
            res.some(esl => Number(eas.point) === Number(esl.value) && eas.uuidConfig === esl.uuidConfig)
          );
        } else {
           essay.asFound = [];
        }
        
        for (const rf of res) {
          const exists = essay.asFound?.some(esl => Number(esl.point) === Number(rf.value) && esl.uuidConfig === rf.uuidConfig);

          if (!exists) {
            const newAsFound = new CalibrationBalanceEssayAsFound();
            newAsFound.point = rf.value;
            newAsFound.uuidConfig = rf.uuidConfig;
            newAsFound.uuidPattern = rf.uuidPattern;
            const resPattern = patterns.find(ep => ep.uuidConfig === rf.uuidConfig);;
            const resValues = resPattern.values.find(epv => Number(epv.value) === Number(rf.value));
            newAsFound.pattern = resValues.nominal;

            essay.asFound.push(newAsFound);
          }
        }

        this.updateTable(this.asFoundTables);
      } else {
        essay.asFound = [];
      }
    });
  }


  showBtnPoints(idEssayType: number) {
    return idEssayType === BalanceEssayTypeEnum.ESSAY_REPEATABILTY || idEssayType === BalanceEssayTypeEnum.ESSAY_MINIMUM_WEIGHT;
  }

  onBlurSpm(indexVariable: number, essay: CalibrationBalanceVariableEssay) {
    if (essay.rangeScale && essay.toleratedPercentage) {
      const essayRep = this.calibration.variables[indexVariable].essays?.find(ess => ess.idEssayType ===  BalanceEssayTypeEnum.ESSAY_REPEATABILTY);

      essay.asLeft.forEach(aL => {
        let resLeft = essayRep.asLeft.find(erep => Number(erep.point) === Number(aL.point) && erep.uuidConfig === aL.uuidConfig);
        if (resLeft) {
          const devesta =  this.getDevestaValue(resLeft);
          const pmUSP = 2000 * devesta;
          aL.spm = ((2 * devesta / pmUSP) * 100);
          aL.spmResulted = aL.spm / essay.toleratedPercentage; 
          aL.spmCalculated = 820 * essay.rangeScale;
          aL.minumunResult = devesta;
        
          aL.pMResult = Math.max(pmUSP, aL.spmCalculated);
          aL.uspCompliant = (2 * devesta / aL.pMResult) * 100 < 0.1;
        }
      });
    }
  }

  deleteConfigRow(idVariable: number, index: number): void {
    const calibration = this.calibration.variables[idVariable];

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: this.translate.instant('calibrateEquipmentEdit.form.deleteConfig.confirm') as string
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result === true) {
        const config = calibration.configs[index];
        if (calibration.configs?.length > 1) {
          calibration.patterns?.forEach(cp => {
             cp.values = cp.values.filter(cpv => cpv.uuidConfig !== config.uuidConfig);
          });
        } else {
          calibration.patterns.splice(0, 1);
        }
        
        calibration.essays?.forEach(es => {
          es.asLeft = es.asLeft?.filter(easl => easl.uuidConfig !== config.uuidConfig) || [];
        });
        calibration.configs.splice(index, 1);
        this.calculateResult();
        this.updateTable(this.configTables);
        this.updateTable(this.asLeftTables);
        this.updateTable(this.patternsTables);
        this.updateTable(this.asLeftTableEccentricity);
        this.updateTable(this.asLeftRepetibilityTables);
        this.updateTable(this.asLeftTableMinimumWeight);
      }
    });
  }
  
  getPMCalculated(essay: CalibrationBalanceVariableEssay): number {
    if (!essay || !essay.asLeft || essay.asLeft.length === 0) {
      return 0;
    }

    const values = essay.asLeft
    .map(e => e.pMResult)
    .filter(v => typeof v === "number" && !isNaN(v));

    if (values.length === 0) {
      return 0;
    }

    return Math.max(...values);
  }

  onHideEditLeft(left: CalibrationBalanceEssayAsLeft) {
    return left.values?.length > 1;
  }

  onHidePattern(indexVariable: number) {
    return this.calibration.variables[indexVariable].patterns?.length > 0;
  }

  newAsFoundRow(idVariable: number, idEssay: number): void {
    const variable = this.calibration.variables[idVariable];

    const dialogRef = this.dialog.open(CalibrationBalanceEditAsFoundDialogComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        item: new CalibrationBalanceEssayAsFound(),
        variable
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: CalibrationBalanceEssayAsFound) => {

      if (result != null) {
        if (!variable.essays[idEssay].asFound) {
          variable.essays[idEssay].asFound =[];
        }
        variable.essays[idEssay].asFound.push(result);

        this.updateTable(this.asFoundTables);
      }
    });
  }

  editAsFoundRow(idVariable: number, idEssay: number, index: number): void {
    const variable = this.calibration.variables[idVariable];

    const row = variable.essays[idEssay].asFound[index];

    const dialogRef = this.dialog.open(CalibrationBalanceEditAsFoundDialogComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        item: _.cloneDeep(row),
        variable
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: CalibrationBalanceEssayAsFound) => {

      if (result != null) {
        variable.essays[idEssay].asFound[index] = result;

        this.updateTable(this.asFoundTables);
      }
    });
  }

  deleteAsFoundRow(idVariable: number, idEssay: number, index: number): void {
    const calibration = this.calibration.variables[idVariable];
    calibration.essays[idEssay].asFound.splice(index, 1);

    this.updateTable(this.asFoundTables);
  }

  async getBalanceMass(indexVariable: number, idEquipment: number): Promise<void> {
    try {
      const variable = this.calibration.variables[indexVariable];

      const mass = await firstValueFrom(
        this.calibrationBalanceService.getMassFromEquipment(idEquipment, variable.idVariable)
      );

       mass.values.forEach(element => {
        this.vBalanceMass.push({
          ...element,
          pointUnit: `${element.point}${mass.unitName}`,
          idUnit: mass.idUnit,
          unit: mass.unitName,
        });
      });

      this.vBalanceMass.sort((v1, v2) => v1.id - v2.id);

    } catch (err) {
      console.error('Error obteniendo masas:', err);
      return null;
    }
  }

  showDownloadButton(): boolean {
    return this.calibration.id != null && this.calibration.hasOwnProperty('id')
      && this.calibration.idStatus !== CalibrationBalanceStatus.EN_EJECUCION && this.calibration.idStatus !== CalibrationBalanceStatus.NO_VALIDO;
  }

  downloadPdf(): void {
    const errors = this.checkCalibration(false, false);
    if (errors.length !== 0) {
      this.snackBarService.sendError(errors.join('\n'));

      return;
    }

    if (this.calibration.idStatus !== CalibrationBalanceStatus.FIRMADO) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          message: this.translate.instant('calibrateEquipmentEdit.dialog.generateReport.confirmSaved') as string
        }
      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
        if (result === true) {
          this.openDialogDownload();
        }
      });
    } else {
      this.openDialogDownload();
    }
  }

  showAutomaticSign(): boolean {
    const current = this.currentUser;

    return this.showSign() && current.automaticSign;
  }

  showManualSign(): boolean {
    const current = this.currentUser;

    return this.showSign() && current.manualSign;
  }

  manualSign(): void {
    const errors = this.checkCalibration(false, true);

    if (errors.length !== 0) {
      this.snackBarService.sendError(errors.join('\n'));

      return;
    }

    this.prepareToSave();

    const dialogRef = this.dialog.open(CalibrationBalanceEditManualSignReportComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {
        calibration: this.calibration,
        reason: this.calibration.reason
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(res => {

      if (res != null) {
        this.findClient();
      }
      this.spinnerService.hide();
    });
  }

  automaticSign(): void {
    const errors = this.checkCalibration(false, true);

    if (errors.length !== 0) {
      this.snackBarService.sendError(errors.join('\n'));

      return;
    }

    this.prepareToSave();

    const dialogRef = this.dialog.open(CalibrationBalanceEditAutomaticSignReportComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {
        calibration: this.calibration,
        equipment: this.equipment
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(res => {

      if (res != null) {

        this.findClient();

      }
      this.spinnerService.hide();
    });
  }

  showAdvance(): boolean {
    return this.calibration.id != null && this.calibration.idStatus === CalibrationBalanceStatus.EN_EJECUCION;
  }

  showBack(): boolean {
    return this.calibration.id != null && this.calibration.idStatus === CalibrationBalanceStatus.PENDIENTE_FIRMA;
  }

  showRevertSign(): boolean {
    const resultRol = this.currentUser?.profiles?.find(e => e.idRole === RoleEnum.MANAGER || e.idRole === RoleEnum.ADMIN);
    return this.calibration.id != null && this.calibration.idStatus === CalibrationBalanceStatus.FIRMADO
      && (resultRol != null && resultRol !== undefined);
  }

  calculateAdvance(): void {
    this.spinnerService.show();

    const errors = this.checkCalibration(false, true);

    if (errors.length !== 0) {
      this.spinnerService.hide();
      this.snackBarService.sendError(errors.join('\n'));

      return;
    }

    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    this.spinnerService.hide();

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {
      if (token) {
        this.spinnerService.show();

        this.calibrationBalanceService.save(this.calibration, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.calibrationBalanceService.advance(this.calibration, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.spinnerService.hide();
            this.reloadPage(this.calibration.id);
          });
        });
      }
    }, error => {
      if (error != null && error.error != null && typeof error.error === 'string') {
        this.snackBarService.sendError(error.error as string);
      } else {
        this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.status.advance.error.generic') as string);
      }
    });
  }

  calculateBack(): void {
    const errors = this.checkCalibration(false, false);

    if (errors.length !== 0) {
      this.snackBarService.sendError(errors.join('\n'));

      return;
    }

    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {
      this.spinnerService.show();
      this.calibrationBalanceService.back(this.calibration, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.spinnerService.hide();
        this.reloadPage(this.calibration.id);
      }, error => {
        this.spinnerService.hide();
        if (error != null && error.error != null && typeof error.error === 'string') {
        this.snackBarService.sendError(error.error as string);
      } else {
        this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.status.back.error.generic') as string);
      }
      });

    }, error => {
      this.spinnerService.hide();
      if (error != null && error.error != null && typeof error.error === 'string') {
        this.snackBarService.sendError(error.error as string);
      } else {
        this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.status.back.error.generic') as string);
      }
    });
  }

  revertSign(): void {
    const errors = this.checkCalibration(false, false);

    if (errors.length !== 0) {
      this.snackBarService.sendError(errors.join('\n'));

      return;
    }

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: this.translate.instant('calibrateEquipmentEdit.form.revertSign.confirm') as string
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result === true) {
        this.requestReason((reason) => {
          if (reason) {
            const dialogRefConfirmation = this.dialog.open(ActionConfirmPasswordComponent, {
              minWidth: '20%',
              maxHeight: '95vh',
              data: {}
            });

            dialogRefConfirmation.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {
              this.spinnerService.show();
              this.calibrationBalanceService.revertSign(this.calibration, reason, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.spinnerService.hide();
                this.reloadPage(this.calibration.id);
              }, error => {
                this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.status.back.error.generic') as string);
                this.spinnerService.hide();
              });

            }, error => {
              this.spinnerService.hide();
              if (error != null && error.error != null && typeof error.error === 'string') {
                this.snackBarService.sendError(error.error as string);
              } else {
                this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.status.back.error.generic') as string);
              }
            });

          }
        });
      }
    });

  }

  getCorretionAsFound(asFound: CalibrationBalanceEssayAsFound): number {
    if (asFound) {
       if (asFound.pattern == null || asFound.equipment == null) {
            return null;
        }
        return NumberUtils.fixPrecision((+asFound.pattern) - asFound.equipment)
    }

    return null;
  }

  getOrderedEssays(indexVariable: number) {
    return this.calibration?.variables[indexVariable]?.essays.sort((a, b) => {
      const indexA = this.orderEssayList.indexOf(a.idEssayType);
      const indexB = this.orderEssayList.indexOf(b.idEssayType);

      return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
    });
  }
  
  private showSign() {
    return this.calibration.idStatus === CalibrationBalanceStatus.PENDIENTE_FIRMA;
  }

  private openDialogDownload() {
    this.dialog.open(CalibrationBalanceEditGenerateReportComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {
        calibration: this.calibration,
        toSign: false
      }
    });
  }
  
  private updateTable(table: MatTable<any> | QueryList<MatTable<any>>) {
    if (table instanceof QueryList) {
      table?.forEach(t => t.renderRows());
    } else {
      table?.renderRows();
    }
  }

  private save(isNew: boolean, callback: (() => void) = null) {
    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {

      if (token != null) {
        this.spinnerService.show();

        this.prepareToSave();

        this.calibrationBalanceService.save(this.calibration, token).pipe(takeUntil(this.destroy$)).subscribe((res: CalibrationBalance) => {
          this.calibration = res;

          this.calibration.calibrationDate = DateUtils.anyToDate(this.calibration.calibrationDate);
          this.calibration.expirationDate = DateUtils.anyToDate(this.calibration.expirationDate);

          if (isNew) {
            this.snackBarService.sendSuccess(this.translate.instant('calibrateEquipmentEdit.form.create.ok') as string);
          } else {
            this.snackBarService.sendSuccess(this.translate.instant('calibrateEquipmentEdit.form.update.ok') as string);
          }

          if (callback) {
            callback();
          } else {
            this.reloadPage(this.calibration.id);
          }

          this.spinnerService.hide();
        }, error => {
          if (error != null && error.error != null && typeof error.error === 'string') {
            this.snackBarService.sendError(error.error as string);
          } else if (isNew) {
            this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.create.error') as string);
          } else {
            this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.update.error') as string);
          }
          this.spinnerService.hide();
        });

      } else {
        this.spinnerService.hide();
      }
    });

  }

  private prepareToSave() {
    this.calibration.expirationDate = DateUtils.anyToDate(this.calibration.expirationDate);
    this.calibration.calibrationDate =  DateUtils.anyToDate(this.calibration.calibrationDate);

    this.calibration.variables?.filter(v => !this.showExtraField(v))?.forEach(v => {
      v.idUnitExtra = null;
      v.idUnitInput = null;
      v.extraField = null;
    });
  }

  private checkCalibration(isForSave: boolean, isForAdvance: boolean): string[] {
    const errors: string[] = [];

    if (this.calibration.idEquipment == null) {
      errors.push(this.translate.instant('calibrateEquipmentEdit.general.name.error') as string);
    }

    if (StringUtils.isEmpty(this.calibration.certificateNum)) {
      errors.push(this.translate.instant('calibrateEquipmentEdit.general.certificateNum.error') as string);
    }

    if (this.calibration.calibrationDate == null) {
      errors.push(this.translate.instant('calibrateEquipmentEdit.general.calibrateDate.error') as string);
    }

    if (isForAdvance) {
      if (!isForSave && this.calibration.id != null && this.calibration.idPlace == null) {
        errors.push(this.translate.instant('calibrateEquipmentEdit.calibrationData.place.error') as string);
      }

      if (this.calibration.id != null) {
        if (ArrayUtils.isEmpty(this.calibration.variables)) {
          errors.push(this.translate.instant('calibrateEquipmentEdit.form.variables.atLeastOne') as string);
        } else {
          this.calibration.variables.forEach(v => {
            const variableName = this.translate.instant('variable.' + v.variableTranslation) as string;

            if (!isForSave && v.idProcedure == null) {
              errors.push(
                this.translate.instant('calibrateEquipmentEdit.form.variables.procedure.error', { variable: variableName }) as string);
            }

            if (this.equipment != null && this.equipment.equipment?.includes('GENERADOR DE AEROSOL') && v?.idVariable === VariableTypeEnum.PORCENTAJE) {
              if (v.ambientConditions.oilUsed === null) {
                errors.push(
                  this.translate.instant('calibrateEquipmentEdit.ambientConditions.oilUsed.error', { variable: variableName }) as string);
              }
              if (v.ambientConditions.pressureUsed === null) {
                errors.push(
                  this.translate.instant('calibrateEquipmentEdit.ambientConditions.pressureUsed.error', { variable: variableName }) as string);
              }
              if (v.ambientConditions.temperature === null) {
                errors.push(
                  this.translate.instant('calibrateEquipmentEdit.ambientConditions.temperature.error', { variable: variableName }) as string);
              }
            } else {    
              if (ArrayUtils.isEmpty(v.essays)) {
                errors.push(
                  this.translate.instant('calibrateEquipmentEdit.form.variables.essay.essaytOne', { variable: variableName }) as string);
              }else if (ArrayUtils.isEmpty(v.configs)) {
                errors.push(
                  this.translate.instant('calibrateEquipmentEdit.form.variables.config.atLeastOne', { variable: variableName }) as string);
              } else {
                if (ArrayUtils.isEmpty(v.patterns)) {
                  errors.push(
                    this.translate.instant('calibrateEquipmentEdit.form.variables.patterns.atLeastOne', { variable: variableName }) as string);
                }
              }

              v.essays.filter((essay: CalibrationBalanceVariableEssay) => {
                const essayName = this.translate.instant('balanceEssayType.' + essay.essayTranslation) as string;

                if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_TARE) {
                  if (!essay.essayPreload) {
                    errors.push(
                      this.translate.instant('calibrateEquipmentEdit.form.variables.preload.error', { essay: essayName, variable: variableName }) as string);
                  }

                  if (!essay.essayLoad) {
                    errors.push(
                      this.translate.instant('calibrateEquipmentEdit.form.variables.load.error', { essay: essayName, variable: variableName }) as string);
                  }

                  if (!essay.essayLoadRead) {
                    errors.push(
                      this.translate.instant('calibrateEquipmentEdit.form.variables.readLoad.error', { essay: essayName, variable: variableName }) as string);
                  }
                } else if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_MINIMUM_WEIGHT) {
                  if (!essay.rangeScale) {
                    errors.push(
                      this.translate.instant('calibrateEquipmentEdit.form.variables.rangeScale.error', { essay: essayName, variable: variableName }) as string);
                  }
                  if (!essay.toleratedPercentage) {
                    errors.push(
                      this.translate.instant('calibrateEquipmentEdit.form.variables.toleratedPercentage.error', { essay: essayName, variable: variableName }) as string);
                  }
                  if (!essay.asLeft) {
                    errors.push(
                      this.translate.instant('calibrateEquipmentEdit.form.variables.asValue.error', { essay: essayName, variable: variableName }) as string);
                  }
                } else if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL) {
                    essay.asLeft.filter((aL: CalibrationBalanceEssayAsLeft) => aL.pattern == null).forEach((aL: CalibrationBalanceEssayAsLeft) => {
                      errors.push(this.translate.instant('calibrateEquipmentEdit.form.variables.essay.asLeft.error',
                        { point: aL.point, variable: variableName, essay: essayName }) as string);
                    });

                    essay.asLeft?.filter((aL: CalibrationBalanceEssayAsLeft) => aL.correction == null).forEach((aL: CalibrationBalanceEssayAsLeft) => {
                      errors.push(this.translate.instant('calibrateEquipmentEdit.form.variables.essay.asLeft.correction.error',
                        { point: aL.point, variable: variableName, essay: essayName }) as string);
                    });

                    essay.asLeft?.filter((aL: CalibrationBalanceEssayAsLeft) => aL.average == null)?.forEach((aL: CalibrationBalanceEssayAsLeft) => {
                      errors.push(this.translate.instant('calibrateEquipmentEdit.form.variables.essay.asLeft.average.error',
                        { point: aL.point, variable: variableName, essay: essayName }) as string);
                    });
                } else if (essay.idEssayType === BalanceEssayTypeEnum.ESSAY_ECCENTRICITY) {
                  essay.asLeft?.filter((aL: CalibrationBalanceEssayAsLeft) => ArrayUtils.isEmpty(aL.values))?.forEach((aL: CalibrationBalanceEssayAsLeft) => {
                    errors.push(
                      this.translate.instant('calibrateEquipmentEdit.form.variables.essay.asleft',  { point: aL.point, variable: variableName, essay: essayName }) as string);
                  
                  });
                } else {
                   const countValues = essay.asLeft.map((aL: CalibrationBalanceEssayAsLeft) => ArrayUtils.isEmpty(aL.values) ? 0 : aL.values.length)
                    .filter(ArrayUtils.unique).filter(l => l !== 0);
                  if (countValues.length > 1) {
                    errors.push(
                      this.translate.instant('calibrateEquipmentEdit.form.variables.essay.asleft', { essay: essayName, variable: variableName }) as string);
                  }
                }
              });
            }
          });
        }
      }
    }

    return errors;
  }
    
  private onEquipmentChange(equipmentSelected: InternalEquipment) {
      this.equipment = equipmentSelected;
      if (this.equipment.performances?.length > 0) {
        const rCalibration = this.equipment.performances.find(t => t.idActionType === 1);
        if (rCalibration) {
          this.equipmentCalibration = rCalibration;

          if (this.equipmentCalibration?.frequency &&  this.equipmentCalibration?.frequency?.match('^[0-9]+$')) {
            this.calibration.expirationDate = _.cloneDeep(this.calibration.calibrationDate);
            this.calibration.expirationDate.setMonth(this.calibration.expirationDate.getMonth() + Number(this.equipmentCalibration.frequency));
          } else {
            this.calibration.expirationDate = _.cloneDeep(this.calibration.calibrationDate);
            this.calibration.expirationDate.setFullYear(this.calibration.expirationDate.getFullYear() + 1);
          }
        }
      }
      this.calibration.idEquipment = equipmentSelected.id;
      this.calculateClientData();
    }

    private calculateClientData() {
      if (this.equipment.client != null) {
        this.clientName = this.equipment.client.name;
        this.clientAddress = this.equipment.client.addressLine1 + '\n' + this.equipment.client.addressLine2;
  
        this.spinnerService.hide();
      } else {
        this.manageGroupsService.findCurrent().pipe(takeUntil(this.destroy$)).subscribe((g: Group) => {
          g = GroupUtils.objectToGroup(g);
          this.clientName = g.name;
          this.clientAddress = g.getFullAddress();
  
          this.spinnerService.hide();
        }, () => this.spinnerService.hide());
      }
    }

  private reloadPage(idCalibration: number): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    let url: string;
    if (this.router.url.includes('calibrates')) {
      url = `calibrates/calibration?id=${idCalibration}`
    } else if (this.router.url.includes('thermal')) {
      url = `thermal/calibration?id=${idCalibration}`
    } else if (this.router.url.includes('balances')) {
      url = `balances/calibration?id=${idCalibration}`
    }
    void this.router.navigateByUrl(url);
  }

  private requestReason(callback: (reason: string) => void) {
    const dialogRef = this.dialog.open(ReasonDialogComponent, {
      minWidth: '40%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        callback(result);
      }
    });
  }

  private recalculateValues(indexVariable: number, indexEssay: number, indexLeft: number, _values: CalibrationBalanceEssayAsLeftValue[], _resolution: number, _patterns: number[]): void {
      let values: number[] = [];
      if (!ArrayUtils.isEmpty(_values)) {
          values = _values.map(v => v.value);
      }

      const resolution = _resolution;
      let patterns = [];

      if (_patterns) {
          patterns = _patterns.map(p => p / 2);
      }

      let asLeft = this.calibration.variables[indexVariable].essays[indexEssay].asLeft[indexLeft];
      // Si algún valor es nulo no recalculamos los valores y así evitamos errores
      if (ArrayUtils.isEmpty(values) || resolution == null || ArrayUtils.isEmpty(patterns)) {
          return;
      }

      asLeft.average = NumberUtils.fixPrecision(+NumberUtils.average(values));
      asLeft.correction = NumberUtils.fixPrecision((+asLeft.pattern) - asLeft.average);

      const standarDevs = NumberUtils.fixPrecision(NumberUtils.standardDeviation(values));
      const totalValues = values.length;
      asLeft.devesta = standarDevs;
      asLeft.uRep = NumberUtils.fixPrecision(standarDevs / Math.sqrt(totalValues));
              
      asLeft.uResol = resolution / Math.sqrt(12);

      asLeft.uEstab = (Math.max(...values) - Math.min(...values)) / (2) / (Math.sqrt(3));
      const dataUC: number[] = [];
      dataUC.push(asLeft.uRep);
      dataUC.push(asLeft.uResol);
      dataUC.push(asLeft.uUnif);
      dataUC.push(asLeft.uEstab);

      if (patterns != null) {
          patterns.filter(d => d != null).forEach(d => dataUC.push(d));
      }

      let counterUC = 0.0;
      dataUC.filter(d => d != null).forEach(d => counterUC += Math.pow(d, 2));

      asLeft.uC = Math.sqrt(counterUC);

      if (asLeft.uRep === 0) {
          asLeft.neff = Infinity;
      } else {
          const dataNeff = [asLeft.uRep, asLeft.uResol, asLeft.uUnif, ...asLeft.patterns, asLeft.uEstab];

          let counterNeff = 0.0;
          dataNeff.filter(d => d != null).forEach(d => counterNeff += (Math.pow(d, 4)) / (totalValues - 1));

          asLeft.neff = (Math.pow(asLeft.uC, 4) / counterNeff);
      }

      let resultK: number;

      if (asLeft.neff < 10) {
          resultK = 2.37;
      } else if (asLeft.neff < 20) {
          resultK = 2.28;
      } else if (asLeft.neff < 50) {
          resultK = 2.13;
      } else {
          resultK = 2;
      }

      asLeft.k = resultK;

      asLeft.U = asLeft.uC * asLeft.k;

      asLeft.cPlusU = Math.abs(asLeft.correction) + asLeft.U;
      asLeft.pattern = asLeft.pattern;
    }


  private calcularUHist(data: number[]): number {
    const n = data.length;
    
    const mitad = Math.floor(n / 2);
    const grupoArriba = data.slice(0, mitad + (n % 2));
    const grupoAbajo = data.slice(mitad + (n % 2));

    const meanUp = NumberUtils.average(grupoArriba);
    const meanDown = NumberUtils.average(grupoAbajo);

    const H = Math.abs(meanUp - meanDown);
    const uHist = H / Math.sqrt(12);

    return uHist;
  }

  private cloneRow(id: number, idGroup: number): Promise<void> {

    return new Promise<void>((resolve) => {

      const dialogRefConfirm = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          message: this.translate.instant('generic.clone.sign') as string
        }
      });

      dialogRefConfirm.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: boolean) => {
        if (result === true) {

          this.spinnerService.show();

          this.calibrationBalanceService.checkCopyToGroup(id, idGroup).subscribe((res: GenericWarnError) => {
            this.spinnerService.hide();

            const dialogRef = this.dialog.open(CheckWarnsErrorsComponent, {
              minWidth: '20%',
              maxHeight: '95vh',
              data: {
                warns: res.warns,
                errors: res.errors
              }
            });

            dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((canContinue: boolean) => {
              if (canContinue === true) {
                this.spinnerService.show();
                if (!this.equipment.internal) {
                  this.internalEquipmentService.getAllByGroup(idGroup, this.calibration.idEquipment).subscribe((resFolder: InternalEquipmentFolder[]) => {
                    this.spinnerService.hide();
                    if (resFolder?.length > 0) {
                      const dialogRefFolders = this.dialog.open(InternalEquipmentSelectFolderComponent, {
                        minWidth: '20%',
                        maxHeight: '95vh',
                        data: {
                          folders: resFolder
                        }
                      });
                      dialogRefFolders.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((idFolder: number) => {
                        if (idFolder) {
                          this.spinnerService.show();
                          this.calibrationBalanceService.copyToGroupWithFolder(id, idGroup, idFolder).subscribe(() => {
                            this.spinnerService.hide();
                            this.snackBarService.sendSuccess(this.translate.instant('isothermalCharacterizationEdit.form.clone.ok') as string);
                            resolve();
                          }, () => {
                            this.spinnerService.hide();
                            this.snackBarService.sendError(this.translate.instant('isothermalCharacterizationEdit.form.clone.error') as string);
                            resolve();
                          });
                        } else {
                          this.spinnerService.show();
                          this.calibrationBalanceService.copyToGroup(id, idGroup).subscribe(() => {
                            this.spinnerService.hide();
                            this.snackBarService.sendSuccess(this.translate.instant('calibrateEquipmentEdit.form.clone.ok') as string);
                            resolve();
                          }, () => {
                            this.spinnerService.hide();
                            this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.clone.error') as string);
                            resolve();
                          });
                        }
                      });
                    } else {
                      this.spinnerService.show();
                      this.calibrationBalanceService.copyToGroup(id, idGroup).subscribe(() => {
                        this.spinnerService.hide();
                        this.snackBarService.sendSuccess(this.translate.instant('calibrateEquipmentEdit.form.clone.ok') as string);
                        resolve();
                      }, () => {
                        this.spinnerService.hide();
                        this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.clone.error') as string);
                        resolve();
                      });
                    }
                  });
                } else {
                  this.spinnerService.show();
                  this.calibrationBalanceService.copyToGroup(id, idGroup).subscribe(() => {
                    this.spinnerService.hide();
                    this.snackBarService.sendSuccess(this.translate.instant('calibrateEquipmentEdit.form.clone.ok') as string);
                    resolve();
                  }, () => {
                    this.spinnerService.hide();
                    this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.clone.error') as string);
                    resolve();
                  });
                }
              } else {
                resolve();
              }
            });
          }, () => {
            this.spinnerService.hide();
            this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.clone.error') as string);
            resolve();
          });
        } else {
          resolve();
        }
      });

    });
  }

  private findClient(): void {
    if (this.equipment.internal) {
      this.reloadPage(this.calibration.id);
    } else {
      this.clientService.findOne(this.equipment.client.id).subscribe((client: Client) => {

        if (client.idGroup != null) {
          void this.cloneRow(this.calibration.id, client.idGroup).then(() => this.reloadPage(this.calibration.id));
        } else {
          this.reloadPage(this.calibration.id);
        }

      });
    }
  }

  private findUuidConfig(indexVariable: number, uuidConfig: string): CalibrationBalanceVariableConfig {
    return this.calibration.variables[indexVariable].configs.find(dc => dc.uuidConfig === uuidConfig);
  }
}
